import { StepMetadata } from './workflow-types';

type IHMetadataType = {
  steps: StepMetadata[];
};

export const IHMetadata: IHMetadataType = {
  steps: [
    {
      adapterName: 'AddDataSourceRowsTask',
      inputs: [
        {
          key: 'dataSourceId',
          label: 'DataSource',
          editor: 'select',
          source: 'datasources',
          placeholder: 'Select a DataSource',
          required: true,
          type: 'text'
        },
        {
          key: 'dataSet',
          label: 'DataSet',
          editor: 'text',
          required: true,
          type: 'text'
        },
        {
          key: 'dataSetKeyColumn',
          label: 'DataSet Key Column',
          editor: 'text',
          required: true,
          type: 'text'
        },
        {
          key: 'columnOrder',
          label: 'Column Order',
          editor: 'text',
          required: true,
          type: 'text'
        }
      ]
    },
    {
      adapterName: 'ChangeFormStatusTask',
      inputs: [
        {
          key: 'formId',
          label: 'Form Id',
          editor: 'text',
          type: 'text'
        },
        {
          key: 'formStatus',
          label: 'Form Status',
          editor: 'select',
          source: 'array',
          values: [
            {
              label: 'Complete',
              value: 'complete'
            },
            {
              label: 'Draft',
              value: 'draft'
            }
          ],
          placeholder: 'Select Form Status',
          required: true,
          type: 'text'
        }
      ]
    },
    {
      adapterName: 'CreateFormTask',
      inputs: [
        {
          key: 'templateId',
          label: 'Template',
          editor: 'select',
          source: 'templates',
          placeholder: 'Select a Template',
          required: true,
          type: 'text'
        },
        {
          key: 'formName',
          label: 'Form Name',
          editor: 'text',
          required: true,
          type: 'text'
        },
        {
          key: 'assignmentType',
          label: 'Owner Type',
          editor: 'select',
          source: 'array',
          values: [
            {
              label: 'User',
              value: 'user'
            },
            {
              label: 'Group',
              value: 'group'
            }
          ],
          placeholder: 'Select Owner Type',
          required: true,
          type: 'text'
        },
        {
          key: 'userId',
          label: 'User Id',
          editor: 'text',
          helpText: 'This should be set if the Owner Type is User.',
          type: 'text'
        },
        {
          key: 'groupId',
          label: 'Group Id',
          editor: 'text',
          helpText: 'This should be set if the Owner Type is Group.',
          type: 'text'
        },
        {
          key: 'fields',
          label: 'Fields',
          type: 'objectList',
          properties: [
            {
              key: 'fieldName',
              label: 'Field Name',
              editor: 'text',
              helpText: 'Name of the GoFormz template field',
              type: 'text'
            },
            {
              key: 'value',
              label: 'Value',
              editor: 'text',
              type: 'text',
              helpText: 'This is what the field value will be'
            }
          ]
        }
      ],
      outputs: [
        {
          key: 'formId',
          type: 'text'
        }
      ]
    },
    {
      adapterName: 'CreatePublicFormTask',
      inputs: [
        {
          key: 'formId',
          label: 'Form Id',
          editor: 'text',
          required: true,
          type: 'text'
        },
        {
          key: 'name',
          label: 'Public Form Name',
          editor: 'text',
          required: true,
          type: 'text'
        },
        {
          key: 'recipientName',
          label: 'Recipient Name',
          editor: 'text',
          required: true,
          type: 'text'
        },
        {
          key: 'recipientEmail',
          label: 'Recipient Email',
          editor: 'text',
          required: true,
          type: 'text'
        },
        {
          key: 'emailSubject',
          label: 'Email Subject',
          editor: 'text',
          required: false,
          type: 'text'
        },
        {
          key: 'emailBody',
          label: 'Email Body',
          editor: 'textarea',
          required: false,
          type: 'text'
        },
        {
          key: 'fields',
          label: 'Editable Fields',
          editor: 'text',
          required: true,
          helpText: "Comma separated list of the names of the editable fields. To make all fields editable, use a value of 'all'",
          type: 'text'
        },
        {
          key: 'viewType',
          label: 'View Type',
          editor: 'select',
          source: 'array',
          values: [
            {
              label: 'Form View',
              value: '0'
            },
            {
              label: 'List View',
              value: '1'
            }
          ],
          placeholder: 'Select View Type',
          required: true,
          type: 'text'
        },
        {
          key: 'expirationTime',
          label: 'Expiration Time',
          editor: 'text',
          required: false,
          helpText: 'Number of hours before the link expires. Leave blank for no expiration date.',
          type: 'text'
        }
      ],
      outputs: [
        {
          key: 'policyId',
          type: 'text'
        }
      ]
    },
    {
      adapterName: 'DeleteDataSourceRowsTask',
      inputs: [
        {
          key: 'dataSourceId',
          label: 'DataSource',
          editor: 'select',
          source: 'datasources',
          placeholder: 'Select a DataSource',
          required: true,
          type: 'text'
        }
      ]
    },
    {
      adapterName: 'DeleteFormTask',
      inputs: [
        {
          key: 'formId',
          label: 'Form Id',
          required: true,
          editor: 'text',
          type: 'text'
        }
      ]
    },
    {
      adapterName: 'ExportFormToPdfTask',
      inputs: [
        {
          key: 'formId',
          label: 'Form Id',
          editor: 'text',
          required: true,
          type: 'text'
        },
        {
          key: 'pages',
          label: 'Pages',
          placeholder: 'e.g. 1, 2, 4-6 (leave blank for all)',
          editor: 'text',
          type: 'text'
        },
        {
          key: 'filename',
          label: 'Filename',
          helpText: 'The extension .pdf is automatically added to your filename. If left blank the form name will be used.',
          editor: 'text',
          type: 'text'
        }
      ],
      outputs: [
        {
          key: 'pdfUrl',
          type: 'text'
        },
        {
          key: 'fileList',
          type: 'fileList'
        }
      ]
    },
    {
      adapterName: 'ExportReportViewToCsvTask',
      inputs: [
        {
          key: 'reportViewId',
          label: 'Report',
          editor: 'select',
          source: 'reportViews',
          placeholder: 'Select a Report',
          required: true,
          type: 'text'
        },
        {
          key: 'delimiter',
          label: 'Export Delimiter',
          helpText: 'Defaults to ,',
          editor: 'text',
          type: 'text'
        },
        {
          key: 'includeNewlineCharacters',
          label: 'Include Newline Characters',
          editor: 'bool',
          type: 'bool'
        }
      ],
      outputs: [
        {
          key: 'csvUrls',
          type: 'fileList'
        }
      ]
    },
    {
      adapterName: 'FillFormFieldsTask',
      inputs: [
        {
          key: 'formId',
          label: 'Form Id',
          required: true,
          editor: 'text',
          type: 'text'
        },
        {
          key: 'dataSet',
          label: 'DataSet',
          editor: 'text',
          type: 'text'
        },
        {
          key: 'fieldMapping',
          label: 'Field Mapping',
          editor: 'text',
          type: 'text'
        }
      ]
    },
    {
      adapterName: 'FillFormTableTask',
      inputs: [
        {
          key: 'formId',
          label: 'Form Id',
          required: true,
          editor: 'text',
          type: 'text'
        },
        {
          key: 'dataSet',
          label: 'DataSet',
          editor: 'text',
          type: 'text'
        },
        {
          key: 'tableName1',
          label: 'tableName1',
          editor: 'text',
          type: 'text'
        },
        {
          key: 'tableMapping1',
          label: 'tableMapping1',
          editor: 'text',
          type: 'text'
        }
      ],
      outputs: [
        {
          key: 'tablesUsed',
          type: 'text'
        }
      ]
    },
    {
      adapterName: 'GetDataSourceTask',
      inputs: [
        {
          key: 'dataSourceId',
          label: 'DataSource',
          editor: 'select',
          source: 'datasources',
          placeholder: 'Select a DataSource',
          required: true,
          type: 'text'
        },
        {
          key: 'rowLimit',
          label: 'Row Limit',
          editor: 'text',
          type: 'text'
        }
      ],
      outputs: [
        {
          key: 'dataSet',
          type: 'dataSet'
        },
        {
          key: 'dataSetUrl',
          type: 'text'
        },
        {
          key: 'storageFileName',
          type: 'text'
        }
      ]
    },
    {
      adapterName: 'GetFormJsonTask',
      inputs: [
        {
          key: 'formId',
          label: 'Form Id',
          editor: 'text',
          type: 'text'
        },
        {
          key: 'filename',
          label: 'Filename',
          editor: 'text',
          helpText: 'If left blank the filename will be <formid>.json',
          type: 'text'
        }
      ],
      outputs: [
        {
          key: 'fileList',
          type: 'fileList'
        }
      ]
    },
    {
      adapterName: 'GetFormImagesTask',
      inputs: [
        {
          key: 'formId',
          label: 'Form Id',
          required: true,
          editor: 'text',
          type: 'text'
        },
        {
          key: 'getRetainedImages',
          label: 'Get Retained Images',
          editor: 'bool',
          type: 'bool'
        },
        {
          key: 'filter',
          label: 'Filter',
          editor: 'text',
          type: 'text'
        }
      ],
      outputs: [
        {
          key: 'fileList',
          type: 'fileList'
        }
      ]
    },
    {
      adapterName: 'GetFormTableTask',
      inputs: [
        {
          key: 'formId',
          label: 'Form Id',
          required: true,
          editor: 'text',
          type: 'text'
        },
        {
          key: 'tableName1',
          label: 'tableName1',
          editor: 'text',
          type: 'text'
        }
      ],
      outputs: [
        {
          key: 'dataSet',
          type: 'dataSet'
        },
        {
          key: 'dataSetUrl',
          type: 'text'
        },
        {
          key: 'storageFileName',
          type: 'text'
        }
      ]
    },
    {
      adapterName: 'GetFormTask',
      inputs: [
        {
          key: 'formId',
          label: 'Form Id',
          required: true,
          editor: 'text',
          type: 'text'
        }
      ],
      outputs: [
        {
          key: 'formId',
          type: 'text'
        },
        {
          key: 'formName',
          type: 'text'
        },
        {
          key: 'formStatus',
          type: 'text'
        },
        {
          key: 'formChangeDate',
          type: 'text'
        },
        {
          key: 'formLastUpdateDate',
          type: 'text'
        },
        {
          key: 'formTemplateId',
          type: 'text'
        },
        {
          key: 'formLocationLatitude',
          type: 'text'
        },
        {
          key: 'formLocationLongitude',
          type: 'text'
        },
        {
          key: 'formLocationAccuracy',
          type: 'text'
        },
        {
          key: 'formAssignmentId',
          type: 'text'
        },
        {
          key: 'formAssignmentType',
          type: 'text'
        },
        {
          key: 'formAssignmentUrl',
          type: 'text'
        }
      ]
    },
    {
      adapterName: 'UpdateDataSourceRowsTask',
      inputs: [
        {
          key: 'dataSourceId',
          label: 'DataSource',
          editor: 'select',
          source: 'datasources',
          placeholder: 'Select a DataSource',
          required: true,
          type: 'text'
        },
        {
          key: 'dataSetKeyColumn',
          label: 'DataSet KeyColumn',
          required: true,
          editor: 'text',
          type: 'text'
        },
        {
          key: 'columnOrder',
          label: 'Column Order',
          required: true,
          editor: 'text',
          type: 'text'
        },
        {
          key: 'rowLimit',
          label: 'Row Limit',
          editor: 'text',
          type: 'text'
        },
        {
          key: 'updateDataSet',
          label: 'Update DataSet',
          required: true,
          editor: 'text',
          type: 'text'
        },
        {
          key: 'dataSet',
          label: 'DataSet',
          required: true,
          editor: 'text',
          type: 'text'
        }
      ]
    },
    {
      adapterName: 'UpdateFormTask',
      inputs: [
        {
          key: 'formId',
          label: 'Form Id',
          required: true,
          editor: 'text',
          type: 'text'
        },
        {
          key: 'fields',
          label: 'Fields',
          type: 'objectList',
          properties: [
            {
              key: 'fieldName',
              label: 'Field Name',
              editor: 'text',
              helpText: 'Name of the GoFormz template field',
              type: 'text'
            },
            {
              key: 'value',
              label: 'Value',
              editor: 'text',
              helpText: 'This is what the field value will be',
              type: 'text'
            }
          ]
        }
      ]
    },
    {
      adapterName: 'UpsertDataSourceRowTask',
      inputs: [
        {
          key: 'datasource_id',
          label: 'DataSource',
          editor: 'select',
          source: 'datasources',
          placeholder: 'Select a DataSource',
          required: true,
          type: 'text'
        }
      ]
    },
    {
      adapterName: 'SendEmailTask',
      inputs: [
        {
          key: 'to',
          alternateKeys: ['email_to'],
          label: 'To',
          editor: 'text',
          required: true,
          helpText: 'Separate multiple email addresses with commas',
          type: 'text'
        },
        {
          key: 'cc',
          label: 'CC',
          editor: 'text',
          type: 'text'
        },
        {
          key: 'bcc',
          label: 'BCC',
          editor: 'text',
          type: 'text'
        },
        {
          key: 'subject',
          alternateKeys: ['email_subject'],
          label: 'Subject',
          editor: 'text',
          placeholder: 'Default: Message from GoFormz',
          type: 'text'
        },
        {
          key: 'body',
          alternateKeys: ['email_body'],
          label: 'Body',
          editor: 'richtext',
          type: 'text'
        },
        {
          key: 'fileUrls',
          label: 'Attachments',
          editor: 'text',
          helpText: 'Pipe (|) delimited urls',
          type: 'fileList'
        }
      ]
    }
  ]
};
